import { Button } from '@/app/common/components/button/Button'
import AppDialog from '@/common/components/Dialog.tsx'
import { PulsingEllipsesLoader } from '@/common/components/PulsingEllipsesLoader.tsx'
import { useAppAlert } from '@/layouts/AppAlertProvider.tsx'
import { createRole } from '@/queries/roles/roles.ts'
import { SyntheticEvent, useState } from 'react'
import { Input } from '@/app/common/components/input/Input'

interface NewRoleProps {
  open: boolean
  close: () => void
  refreshPage: () => void
}
export default function NewRoleView({
  open,
  close,
  refreshPage,
}: NewRoleProps) {
  const [isLoading, setIsLoading] = useState(false)
  const [roleName, setRoleName] = useState<string>('')
  const [roleCode, setRoleCode] = useState<string>('')
  const [description, setDescription] = useState<string>('')

  const { fireAlert } = useAppAlert()

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault()

    if (roleName.trim() == '') {
      await fireAlert({
        variant: 'error',
        message: 'Role Name is required',
      })
      return
    }

    setIsLoading(true)
    await createRole(roleName, roleCode, description)
    setIsLoading(false)

    refreshPage()

    await fireAlert({
      variant: 'success',
      message: 'Role added successfully.',
    })
    close()
  }

  return (
    <>
      <AppDialog open={open} setOpen={() => {}}>
        <AppDialog.Title>New Role</AppDialog.Title>
        <div className="flex flex-col mt-6">
          <form
            id="invite_applicant_form"
            noValidate
            className="space-y-3"
            onSubmit={handleSubmit}
          >
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-bold leading-6 text-gray-900"
              >
                Name<span className="text-danger ml-1">*</span>
              </label>
              <div className="mt-2">
                <Input
                  type="text"
                  required
                  placeholder="Enter Role Name"
                  value={roleName}
                  onChange={(e) => {
                    setRoleName(e.target.value)
                    setRoleCode(e.target.value)
                  }}
                />
              </div>
            </div>
            <div>
              <label
                htmlFor="firstname"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Description
              </label>
              <div className="mt-1">
                <textarea
                  id="description"
                  name="description"
                  rows={4}
                  className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
                  value={description}
                  placeholder={'Enter description'}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
            </div>
          </form>
          <div className="mt-8 flex items-center justify-end gap-x-2">
            <Button
              variant="outline"
              onClick={() => {
                close()
              }}
              type="reset"
              className="h-9 w-32"
            >
              Cancel
            </Button>
            <Button
              form="invite_applicant_form"
              type="submit"
              className="h-9 w-32 disabled:hover:bg-primary disabled:opacity-70"
              disabled={isLoading}
            >
              {isLoading ? (
                <PulsingEllipsesLoader size="md" color="white" />
              ) : (
                'Submit'
              )}
            </Button>
          </div>
        </div>
      </AppDialog>
    </>
  )
}
